module.exports = __webpack_public_path__ + "PTMETTAservice-4.3694069a.png";